import React, { ForwardRefRenderFunction } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { InvoiceFormContainerProps } from "models/propTypes/invoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
//#endregion
//#region  components
import { useAccountService } from "serviceHooks";
import useInvoiceInitialValues from "./useInvoiceInitialValues";
import useInvoiceFormValidations from "./useInvoiceFormValidations";
import InvoiceForm from "./invoiceForm";
//#endregion

const InvoiceFormContainer: ForwardRefRenderFunction<FormHandles, InvoiceFormContainerProps> = (props, ref) => {
  const hasROT = useSelector((store: AppState) => store.auth.selectedCompany.hasROT);
  const hasRUT = useSelector((store: AppState) => store.auth.selectedCompany.hasRUT);
  const accountService = useAccountService();

  // Same read the article form does. Passed down as a prop rather than seeded into the form
  // values: it arrives asynchronously, and defaultValues only seeds Formik once. Until it
  // resolves the flag is undefined, which reads as "not enabled" - the safe default, matching
  // the server's own fail-closed behaviour.
  const [revenueAccountsEnabled, setRevenueAccountsEnabled] = React.useState<boolean>();

  React.useEffect(() => {
    accountService
      .getRevenueAccounts()
      .then((response) => setRevenueAccountsEnabled(response.enabled))
      .catch(() => setRevenueAccountsEnabled(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const invoice = props.invoice ? (props.invoice as WintSuperkollAPIModel.Invoice) : undefined;

  const { getDraftInitialValues, getRecurringInvoiceInitialValues, getInvoiceInitialValues } = useInvoiceInitialValues(
    props.invoice
  );

  const { getValidationSchema } = useInvoiceFormValidations();

  const defaultValues =
    props.invoice === undefined
      ? getDraftInitialValues()
      : props.isRecurring
      ? getRecurringInvoiceInitialValues()
      : getInvoiceInitialValues();

  const defaultDimensions = defaultValues.products?.flatMap((x) => x.dimensions) ?? [];

  return (
    <InvoiceForm
      key={`${props.invoice?.id}-${defaultDimensions}`}
      ref={ref}
      defaultValues={defaultValues}
      validationSchema={getValidationSchema(
        props.isRecurring && props.invoice?.id === undefined,
        false,
        false,
        invoice?.totalReminderCost !== undefined && invoice.totalReminderCost < 0,
        invoice?.creditedInvoiceId !== undefined,
        props.isRecurring
      )}
      onFormValidationChange={props.onFormValidationChange}
      isRecurring={props.isRecurring}
      hasROT={hasROT}
      hasRUT={hasRUT}
      revenueAccountsEnabled={revenueAccountsEnabled}
      reloadInvoice={props.reloadInvoice}
      invoice={invoice}
      showOnlyRecurringFields={props.showOnlyRecurringFields}
      additionalImages={props.additionalImages}
    />
  );
};

export default React.forwardRef(InvoiceFormContainer);
